module.exports = __webpack_public_path__ + "static/img/banner-gift.8655d783.png";